import React from 'react'

import {
  BooleanField,
  DateTimeField,
  FieldSpec,
  LinkedField,
  LinkedPathField,
  PaginatedTable,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import {ListTableProps} from './types'

const fieldOptions: {[key: string]: FieldSpec} = {
  guid: {id: 'guid', label: 'Damaged', renderer: LinkedField(ValueField)},
  client: {id: 'client', label: 'Client', ordering: 'account__name', renderer: RelatedLinkedField(ValueField, 'name')},
  facility: {id: 'facility', label: 'Name', ordering: 'facility__name', renderer: RelatedLinkedField(ValueField, 'name')},
  asn: {id: 'asn', label: 'ASN', ordering: 'asn__tracking_number', renderer: RelatedLinkedField(ValueField, 'name')},
  path: {id: 'objPath', label: 'Path', ordering: 'place__search_path', renderer: LinkedPathField},
  product: {id: 'product', label: 'Product', ordering: 'product__name', renderer: RelatedLinkedField(ValueField, 'name')},
  sku: {id: 'sku', label: 'SKU', ordering: 'sku__sku', renderer: RelatedLinkedField(ValueField, 'sku')},
  batch: {id: 'batch', label: 'Batch', ordering: 'batch__client_uid', renderer: RelatedLinkedField(ValueField, 'name')},
  damage: {id: 'damage', label: 'Damage', renderer: ValueField},
  byUs: {id: 'byUs', label: 'By Us?', ordering: 'by_us', renderer: BooleanField},
  notes: {id: 'notes', label: 'Notes', renderer: ValueField},
  damagedOn: {id: 'damagedOn', label: 'Damaged On', ordering: 'created_on', renderer: DateTimeField},
}

export const DamagedListTable = (props: ListTableProps) => {
  const {paginator, title, fields, exportConfig} = props

  return (
    <>
      <PaginatedTable
        title={title ? title : "Damages"}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
